function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { getDomain } from "tldjs";
import { capitalize } from "lodash";
import { Button, Col, Row } from "antd";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import { isBlank } from "imagica-corekit/dist/base/cutil/Extensions";
import { BlankV2 } from "../Blank/BlankV2";
import style from "./AskBrain.module.scss";
export var AskBrain = function AskBrain(props) {
  var _props$textAreaValue2, _props$textAreaValue4, _props$style, _props$style2, _props$textAreaValue5;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    answerHtml = _useState2[0],
    setAnswerHtml = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    links = _useState4[0],
    setLinks = _useState4[1];
  useEffect(function () {
    var _props$textAreaValue$, _props$textAreaValue;
    setAnswerHtml(((_props$textAreaValue$ = (_props$textAreaValue = props.textAreaValue) === null || _props$textAreaValue === void 0 ? void 0 : _props$textAreaValue.answer) !== null && _props$textAreaValue$ !== void 0 ? _props$textAreaValue$ : "").replace(/\[(\d)+\]/g, function (match, p1) {
      return '<span class="dangerous-html-dot">' + p1 + "</span>";
    }));
  }, [(_props$textAreaValue2 = props.textAreaValue) === null || _props$textAreaValue2 === void 0 ? void 0 : _props$textAreaValue2.answer]);
  useEffect(function () {
    var _props$textAreaValue$2, _props$textAreaValue3;
    var links = ((_props$textAreaValue$2 = (_props$textAreaValue3 = props.textAreaValue) === null || _props$textAreaValue3 === void 0 ? void 0 : _props$textAreaValue3.sources_data) !== null && _props$textAreaValue$2 !== void 0 ? _props$textAreaValue$2 : []).map(function (x, index) {
      // 兼容旧的数据
      if (typeof x === "string") {
        return {
          domain_name: x,
          favicon: "",
          index: index + 1,
          source: x
        };
      }
      if (x.domain_name || x.source) {
        return _objectSpread(_objectSpread({}, x), {}, {
          domain_name: !isBlank(x.domain_name) ? x.domain_name : x.source
        });
      }
      return x;
    }).sort(function (a, b) {
      return a.index - b.index;
    });
    setLinks(links);
  }, [(_props$textAreaValue4 = props.textAreaValue) === null || _props$textAreaValue4 === void 0 ? void 0 : _props$textAreaValue4.sources_data]);
  var askBrainBackground = (_props$style = props.style) !== null && _props$style !== void 0 && _props$style.background ? {
    background: (_props$style2 = props.style) === null || _props$style2 === void 0 ? void 0 : _props$style2.background
  } : {};
  if (isBlank((_props$textAreaValue5 = props.textAreaValue) === null || _props$textAreaValue5 === void 0 ? void 0 : _props$textAreaValue5.answer)) {
    return /*#__PURE__*/React.createElement(BlankV2, null);
  }
  return /*#__PURE__*/React.createElement("div", {
    style: askBrainBackground,
    className: classNames(style["custom-node"], style["design-text"], style["guide-textnode-disable"], _defineProperty({}, style["target"], props.enableFeedback), props.noWheelClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(style["text-content"], " ").concat(style[!props.isShare ? "text-default-padding" : "text-reset-padding"])
  }, /*#__PURE__*/React.createElement("div", {
    style: props.style,
    className: style.html_content,
    dangerouslySetInnerHTML: {
      __html: answerHtml
    }
  }), /*#__PURE__*/React.createElement(Row, {
    gutter: 8,
    className: style["link-box"]
  }, links.map(function (link, index) {
    return /*#__PURE__*/React.createElement(Col, {
      key: index,
      className: style["link-item-col"]
    }, /*#__PURE__*/React.createElement(LinkItem, {
      link: link,
      canvasType: props.canvasType
    }));
  }))));
};
var LinkItem = function LinkItem(_ref) {
  var _getDomain;
  var link = _ref.link,
    canvasType = _ref.canvasType;
  var index = link.index,
    source = link.source,
    domain_name = link.domain_name,
    favicon = link.favicon;
  var defaultLogo = "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "default-link-logo.png");
  var domain = capitalize(((_getDomain = getDomain(domain_name)) !== null && _getDomain !== void 0 ? _getDomain : "").split(".")[0]);
  var handleOpen = function handleOpen(source) {
    window.open(source, "__blank");
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(style["link-item"], " ").concat(canvasType === "saas" ? style["link-item-saas"] : "")
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(style["item-index"])
  }, index), /*#__PURE__*/React.createElement("img", {
    className: style["item-logo"],
    src: favicon !== null && favicon !== void 0 ? favicon : defaultLogo,
    alt: "logo",
    onError: function onError(e) {
      e.target.src = defaultLogo;
    }
  }), /*#__PURE__*/React.createElement(Button, {
    className: style["item-title"],
    type: "link",
    onClick: function onClick() {
      return handleOpen(source);
    }
  }, domain !== null && domain !== void 0 ? domain : "-"));
};